import {SPA_APP_PATH_PATTERN} from "../page-url-broadcaster/page-url-coordination-store";

export enum MENU_ITEM_TYPE {
    BACK_AS_ADMIN = 'BACK_AS_ADMIN',
    MAIN_MENU_ITEM = 'MAIN_MENU_ITEM',
    TOP_LEVEL_COLLAPSIBLE = 'TOP_LEVEL_COLLAPSIBLE',
    COVERAGE_MENU_ITEM = 'COVERAGE_MENU_ITEM',
}

export enum MENU_ITEM_LABEL_KEY {
    HOME = 'HOME',
    RETURNS_AND_EXCHANGES = 'RETURNS_AND_EXCHANGES',
    MANAGE_RETURNS = 'MANAGE_RETURNS',
    SHIP_BY_RETURNGO = 'SHIP_BY_RETURNGO',
    RETURN_COVERAGE = 'RETURN_COVERAGE',
    SETTINGS = 'SETTINGS',
    GENERAL = 'GENERAL',
    LANGUAGES = 'LANGUAGES',
    RETURN_REASONS = 'RETURN_REASONS',
    RESOLUTIONS = 'RESOLUTIONS',
    RETURN_METHODS = 'RETURN_METHODS',
    RETURN_POLICY = 'RETURN_POLICY',
    PORTAL = 'PORTAL',
    EMAIL = 'EMAIL',
    CONTENT = 'CONTENT',
    LOOK_AND_FEEL = 'LOOK_AND_FEEL',
    NOTIFICATIONS = 'NOTIFICATIONS',
    INTEGRATIONS = 'INTEGRATIONS',
    API = 'API',
    STOREFRONT = 'STOREFRONT',
    ANALYTICS = 'ANALYTICS',
    RETURNS = 'RETURNS',
    ORDERS = 'ORDERS',
    SESSIONS = 'SESSIONS',
    CREDITS = 'CREDITS',
    TRANSACTIONS = 'TRANSACTIONS',
    SHIPMENTS = 'SHIPMENTS',
    TROUBLESHOOTING = 'TROUBLESHOOTING',
    BACK_AS_ADMINISTRATOR = 'BACK_AS_ADMINISTRATOR',
    HEALTH_PAGE = 'HEALTH_PAGE',
}

export type MenuItem = RequireLabelKeyOrText & MenuItemBase;

type RequireLabelKeyOrText =
    | { label_key: MENU_ITEM_LABEL_KEY; label_text?: never }
    | { label_key?: never; label_text: string };

type MenuItemBase = {
    type?: MENU_ITEM_TYPE;
    to?: string;
    items?: MenuItem[];
    mixpanelEventName?: string;
}

const menuItems: MenuItem[] = [
    { to: SPA_APP_PATH_PATTERN.DASHBOARD, label_key: MENU_ITEM_LABEL_KEY.HOME, type: MENU_ITEM_TYPE.MAIN_MENU_ITEM, mixpanelEventName: 'd&_sidebar_home' },
    {
        label_key: MENU_ITEM_LABEL_KEY.RETURNS_AND_EXCHANGES,
        type: MENU_ITEM_TYPE.TOP_LEVEL_COLLAPSIBLE,
        mixpanelEventName: 'd&_sidebar_returns_and_exchanges',
        items: [
            { to: SPA_APP_PATH_PATTERN.RETURNS, label_key: MENU_ITEM_LABEL_KEY.MANAGE_RETURNS, mixpanelEventName: 'd&_sidebar_rae_manage_returns' },
            { to: SPA_APP_PATH_PATTERN.SHIP_BY_RETURNGO, label_key: MENU_ITEM_LABEL_KEY.SHIP_BY_RETURNGO, mixpanelEventName: 'd&_sidebar_rae_ship_by_returngo'},
            { to: SPA_APP_PATH_PATTERN.RETURN_COVERAGE, label_key: MENU_ITEM_LABEL_KEY.RETURN_COVERAGE, type: MENU_ITEM_TYPE.COVERAGE_MENU_ITEM, mixpanelEventName: 'd&_sidebar_rae_return_coverage' },  // TODO: feature
        ]
    },
    {
        label_key: MENU_ITEM_LABEL_KEY.SETTINGS,
        type: MENU_ITEM_TYPE.TOP_LEVEL_COLLAPSIBLE,
        mixpanelEventName: 'd&_sidebar_settings',
        items: [
            { to: SPA_APP_PATH_PATTERN.SETTINGS_GENERAL, label_key: MENU_ITEM_LABEL_KEY.GENERAL, mixpanelEventName: 'd&_sidebar_settings_general' },
            { to: SPA_APP_PATH_PATTERN.SETTINGS_LANGUAGES, label_key: MENU_ITEM_LABEL_KEY.LANGUAGES, mixpanelEventName: 'd&_sidebar_settings_languages' },
            { to: SPA_APP_PATH_PATTERN.SETTINGS_RETURN_REASONS, label_key: MENU_ITEM_LABEL_KEY.RETURN_REASONS, mixpanelEventName: 'd&_sidebar_settings_return_reasons' },
            { to: SPA_APP_PATH_PATTERN.SETTINGS_RESOLUTIONS, label_key: MENU_ITEM_LABEL_KEY.RESOLUTIONS, mixpanelEventName: 'd&_sidebar_settings_resolutions' },
            { to: SPA_APP_PATH_PATTERN.SETTINGS_RETURN_METHODS, label_key: MENU_ITEM_LABEL_KEY.RETURN_METHODS, mixpanelEventName: 'd&_sidebar_settings_return_methods' },
            { to: SPA_APP_PATH_PATTERN.SETTINGS_RETURN_POLICIES, label_key: MENU_ITEM_LABEL_KEY.RETURN_POLICY, mixpanelEventName: 'd&_sidebar_settings_return_policy' },
            {
                label_key: MENU_ITEM_LABEL_KEY.PORTAL,
                mixpanelEventName: 'd&_sidebar_settings_portal',
                items: [
                    { to: SPA_APP_PATH_PATTERN.SETTINGS_PORTAL_CONTENT, label_key: MENU_ITEM_LABEL_KEY.CONTENT, mixpanelEventName: 'd&_sidebar_settings_portal_content' },
                    { to: SPA_APP_PATH_PATTERN.SETTINGS_PORTAL_LOOK_AND_FEEL, label_key: MENU_ITEM_LABEL_KEY.LOOK_AND_FEEL, mixpanelEventName: 'd&_sidebar_settings_portal_look_and_feel' }
                ]
            },
            {
                label_key: MENU_ITEM_LABEL_KEY.EMAIL,
                mixpanelEventName: 'd&_sidebar_settings_emails',
                items: [
                    { to: SPA_APP_PATH_PATTERN.SETTINGS_EMAILS_CONTENT, label_key: MENU_ITEM_LABEL_KEY.CONTENT, mixpanelEventName: 'd&_sidebar_settings_emails_content' },
                    { to: SPA_APP_PATH_PATTERN.SETTINGS_EMAILS_LOOK_AND_FEEL, label_key: MENU_ITEM_LABEL_KEY.LOOK_AND_FEEL, mixpanelEventName: 'd&_sidebar_settings_emails_look_and_feel' },
                    { to: SPA_APP_PATH_PATTERN.SETTINGS_EMAILS_NOTIFICATIONS, label_key: MENU_ITEM_LABEL_KEY.NOTIFICATIONS, mixpanelEventName: 'd&_sidebar_settings_emails_notifications' },
                ],
            },
            { to: SPA_APP_PATH_PATTERN.SETTINGS_INTEGRATIONS, label_key: MENU_ITEM_LABEL_KEY.INTEGRATIONS, mixpanelEventName: 'd&_sidebar_settings_integrations'},
            { to: SPA_APP_PATH_PATTERN.SETTINGS_API, label_key: MENU_ITEM_LABEL_KEY.API, mixpanelEventName: 'd&_sidebar_settings_api' },
            { to: SPA_APP_PATH_PATTERN.LOCALIZATION_STOREFRONT, label_key: MENU_ITEM_LABEL_KEY.STOREFRONT, mixpanelEventName: 'd&_sidebar_settings_store_front' },
        ]
    },
    { label_key: MENU_ITEM_LABEL_KEY.ANALYTICS, type: MENU_ITEM_TYPE.TOP_LEVEL_COLLAPSIBLE, mixpanelEventName: 'd&_sidebar_analytics',
        items: [
            { to: SPA_APP_PATH_PATTERN.ANALYTICS_RETURNS, label_key: MENU_ITEM_LABEL_KEY.RETURNS, mixpanelEventName: 'd&_sidebar_analytics_returns' },
            { to: SPA_APP_PATH_PATTERN.ANALYTICS_ORDERS, label_key: MENU_ITEM_LABEL_KEY.ORDERS, mixpanelEventName: 'd&_sidebar_analytics_orders' },
            { to: SPA_APP_PATH_PATTERN.ANALYTICS_SESSIONS, label_key: MENU_ITEM_LABEL_KEY.SESSIONS, mixpanelEventName: 'd&_sidebar_analytics_sessions' },
            { to: SPA_APP_PATH_PATTERN.ANALYTICS_CREDITS, label_key: MENU_ITEM_LABEL_KEY.CREDITS, mixpanelEventName: 'd&_sidebar_analytics_credits' },
            { to: SPA_APP_PATH_PATTERN.ANALYTICS_TRANSACTIONS, label_key: MENU_ITEM_LABEL_KEY.TRANSACTIONS, mixpanelEventName: 'd&_sidebar_analytics_transactions' },
            { to: SPA_APP_PATH_PATTERN.ANALYTICS_SHIPMENTS, label_key: MENU_ITEM_LABEL_KEY.SHIPMENTS, mixpanelEventName: 'd&_sidebar_analytics_shipments' },
        ]
    },
    { to: SPA_APP_PATH_PATTERN.ACCOUNT_HEALTH_PAGE, type: MENU_ITEM_TYPE.MAIN_MENU_ITEM, label_key: MENU_ITEM_LABEL_KEY.HEALTH_PAGE },
    { to: SPA_APP_PATH_PATTERN.TROUBLESHOOTING, type: MENU_ITEM_TYPE.MAIN_MENU_ITEM, label_key: MENU_ITEM_LABEL_KEY.TROUBLESHOOTING },
    { to: SPA_APP_PATH_PATTERN.BACK_TO_SYS_ADMIN, label_key: MENU_ITEM_LABEL_KEY.BACK_AS_ADMINISTRATOR, type: MENU_ITEM_TYPE.BACK_AS_ADMIN },
];

export default menuItems;
